var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.list.length > 0)?_vm._l((_vm.list),function(item){return _c('DoctorListItem',{key:item.id,attrs:{"data":item}})}):_c('div',{staticClass:"p-5 text-center text-muted"},[_vm._v("暂无数据")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }